import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export const COURSE_TRAINER_COST_SCOPE = {
  SESSION: 1,
  DAY: 2,
  COURSE: 3,
} as const;
export type CourseTrainerCostScopeType = (typeof COURSE_TRAINER_COST_SCOPE)[keyof typeof COURSE_TRAINER_COST_SCOPE];

export const TRAINER_RATE_TYPE = {
  HOURLY: 1,
  DAILY: 2,
  TOPIC: 3,
} as const;
export type TrainerRateType = (typeof TRAINER_RATE_TYPE)[keyof typeof TRAINER_RATE_TYPE];

export interface CourseTrainerCostEntryApi {
  id: number;
  trainerId: number;
  trainerFirstName: string;
  trainerSurname: string;
  scopeType: CourseTrainerCostScopeType;
  courseSessionId?: number;
  date?: Date;
  rateType: TrainerRateType;
  rateAmount: number;
  rateSourceName?: string;
  quantitySnapshot?: number;
  calculatedTotal: number;
}

export interface CreateTrainerCostEntryRequest {
  trainerId: number;
  scopeType: CourseTrainerCostScopeType;
  courseSessionId?: number;
  date?: Date;
  rateType: TrainerRateType;
  rateAmount: number;
  rateSourceName?: string;
}

export interface UpdateTrainerCostEntryRequest {
  rateType: TrainerRateType;
  rateAmount: number;
  rateSourceName?: string;
}

const fetchEntries = (courseId: number): AxiosPromise<CourseTrainerCostEntryApi[]> => {
  return api.get<CourseTrainerCostEntryApi[]>(endpoints.TRAINER_COSTS.GET_ENTRIES(courseId));
};

const createEntry = (courseId: number, data: CreateTrainerCostEntryRequest): AxiosPromise => {
  return api.post(endpoints.TRAINER_COSTS.CREATE(courseId), data);
};

const updateEntry = (courseId: number, entryId: number, data: UpdateTrainerCostEntryRequest): AxiosPromise => {
  return api.put(endpoints.TRAINER_COSTS.UPDATE(courseId, entryId), data);
};

const deleteEntry = (courseId: number, entryId: number): AxiosPromise => {
  return api.delete(endpoints.TRAINER_COSTS.DELETE(courseId, entryId));
};

export const trainerCostsApi = {
  fetchEntries,
  createEntry,
  updateEntry,
  deleteEntry,
};
